import React, { useState } from 'react';

export default function ProductCard({ product }) {
  const { brand, name, size, category, description, origin, image, itemsPerBox, available, inStock } = product;
  const [loaded, setLoaded] = useState(false);

  return (
    <article className="bg-parchment border border-border-warm rounded-[4px] overflow-hidden group flex flex-col">
      {/* Image */}
      <div className="aspect-square overflow-hidden shrink-0 relative" style={{ backgroundColor: '#ede8dfd4' }}>
        {image ? (
          <div className="w-full h-full flex items-center justify-center p-6" style={{ backgroundColor: '#ede8dfd4' }}>
            {!loaded && (
              <div className="absolute inset-0 animate-pulse" style={{ backgroundColor: '#ede8dfd4' }} />
            )}
            <img
              src={image}
              alt={`${name} — ${brand}`}
              loading="lazy"
              onLoad={() => setLoaded(true)}
              className={`w-full h-full object-contain transition-[transform,opacity] duration-300 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.03] ${
                loaded ? 'opacity-100' : 'opacity-0'
              }`}
              style={{ filter: 'brightness(1.04) saturate(0.85)', mixBlendMode: 'multiply' }}
            />
          </div>
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center gap-2">
            <span className="font-serif text-lg font-light text-ink-muted tracking-wider">
              {brand}
            </span>
            <div className="w-8 h-px bg-border-warm" />
            <span className="font-sans text-[0.625rem] font-medium tracking-[0.1em] uppercase text-ink-muted/60">
              {category}
            </span>
          </div>
        )}

        {itemsPerBox && (
          <div className="absolute top-2.5 right-2.5 z-10 bg-parchment border border-border-warm rounded-[3px] px-2 py-1 text-center shadow-[0_1px_3px_rgba(22,18,15,0.07)]">
            <span className="block font-serif text-[1.0625rem] leading-none text-ink-deep">
              {itemsPerBox}
            </span>
            <span className="block font-sans text-[0.5rem] font-medium tracking-[0.12em] uppercase text-ink-muted mt-1">
              per box
            </span>
          </div>
        )}
      </div>

      {/* Body */}
      <div className="p-3 sm:p-5 flex flex-col flex-1">
        <div className="flex items-start justify-between gap-2 mb-2">
          <span className="font-sans text-[0.6875rem] font-medium tracking-[0.1em] uppercase text-ink-muted">
            {category}
          </span>
          {!available && (
            <span className="shrink-0 font-sans text-[0.5625rem] font-medium tracking-[0.07em] uppercase text-ink-muted border border-border-warm px-2 py-0.5 rounded-[2px]">
              Coming Soon
            </span>
          )}
          {available && inStock === false && (
            <span className="shrink-0 font-sans text-[0.5625rem] font-medium tracking-[0.07em] uppercase text-[#c0392b] border border-[#c0392b]/30 px-2 py-0.5 rounded-[2px]">
              Out of Stock
            </span>
          )}
        </div>

        <h3 className="font-serif text-[1.25rem] font-normal leading-[1.2] text-ink-deep mt-0.5">
          {name}
          {size && (
            <span className="font-sans text-sm font-normal text-ink-muted ml-1.5 tracking-normal">
              {size}
            </span>
          )}
        </h3>

        <p className="font-sans text-[0.8125rem] text-ink-muted leading-[1.55] mt-2 flex-1">
          {description}
        </p>

        <p className="font-sans text-[0.6875rem] text-ink-muted/70 tracking-[0.05em] mt-3 pt-3 border-t border-border-warm">
          {brand} · {origin}
        </p>
      </div>
    </article>
  );
}
